<!--

Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Vijay Malekar

-->




<!--Top Section-->
<div class="container-fluid mainCADBody">
    <!-- <div class="row">
        <div class="col-md-12">
            <h2 id="headings" class="main-headings">Home</h2>
        </div>
    </div> -->
    
    <!--Search Bar-->

    <div class="row">
        <div class="col-md-12 col-sm-12">
            <!--Mat chips-->
            <mat-label class="search__icon icon-search"></mat-label>
            <mat-form-field class="example-chip-list" appearance="outline">
                <mat-chip-list #chipList aria-label="Fruit selection">

                    <mat-chip *ngFor="let risk of riskFilter " [selectable]="selectable" [removable]="removable" (removed)="removeParticularFilter(risk,riskFilter,'parentRisks')">

                        <div class="tag" *ngIf="riskFilter.length != 0">

                            <div [ngSwitch]="risk">
                                <div *ngSwitchCase="1">
                                    <span class="tag__title"> Risk: Very Low </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(risk,riskFilter,'parentRisks')"></span>

                                </div>
                                <div *ngSwitchCase="2"><span class="tag__title"> Risk: Low </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(risk,riskFilter,'parentRisks')"></span>
                                </div>
                                <div *ngSwitchCase="3"><span class="tag__title"> Risk: Medium </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(risk,riskFilter,'parentRisks')"></span>
                                </div>
                                <div *ngSwitchCase="4"><span class="tag__title"> Risk: High </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(risk,riskFilter,'parentRisks')"></span>
                                </div>
                                <div *ngSwitchCase="5"><span class="tag__title"> Risk: Very High </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(risk,riskFilter,'parentRisks')"></span>
                                </div>
                            </div>

                        </div>

                    </mat-chip>

                    <mat-chip *ngFor="let br of brFilter" [selectable]="selectable" [removable]="removable" (removed)="removeParticularFilter(br,brFilter,'parentProductivities')">

                        <div class="tag" *ngIf="brFilter.length != 0">

                            <div [ngSwitch]="br">
                                <div *ngSwitchCase="1">
                                    <span class="tag__title"> Business Relevance: Very Low </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(br,brFilter,'parentProductivities')"></span>
                                </div>
                                <div *ngSwitchCase="2"><span class="tag__title"> Business Relevance: Low </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(br,brFilter,'parentProductivities')"></span>
                                </div>
                                <div *ngSwitchCase="3"><span class="tag__title"> Business Relevance: Medium </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(br,brFilter,'parentProductivities')"></span>
                                </div>
                                <div *ngSwitchCase="4"><span class="tag__title"> Business Relevance: High </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(br,brFilter,'parentProductivities')"></span>
                                </div>
                                <div *ngSwitchCase="5"><span class="tag__title"> Business Relevance: Very High </span>
                                    <span class="tag__icon icon-close" (click)="removeParticularFilter(br,brFilter,'parentProductivities')"></span>
                                </div>
                            </div>

                        </div>


                    </mat-chip>

                    <mat-chip *ngFor="let tag of tagFilter" [selectable]="selectable" [removable]="removable" (removed)="removeParticularFilter(tag,tagFilter,'tags')">

                        <div class="tag" *ngIf="tagFilter.length != 0">
                            <span class="tag__title"> Tags: {{ tag }} </span>
                            <span class="tag__icon icon-close" (click)="removeParticularFilter(tag,tagFilter,'tags')"></span>
                        </div>

                    </mat-chip>

                    <mat-chip *ngFor="let category of categoryFilter" [selectable]="selectable" [removable]="removable" (removed)="removeParticularFilter(category,categoryFilter,'category')">

                        <div class="tag" *ngIf="categoryFilter.length != 0">
                            <span class="tag__title"> Category: {{ category }} </span>
                            <span class="tag__icon icon-close" (click)="removeParticularFilter(category,categoryFilter,'category')"></span>
                        </div>

                    </mat-chip>

                    <mat-chip *ngFor="let search of searchAppFilter" [selectable]="selectable" [removable]="removable" (removed)="removeParticularFilter(search,searchAppFilter,'appName')">

                        <div class="tag" *ngIf="searchAppFilter.length != 0">
                            <span class="tag__title"> {{ search }} </span>
                            <!-- <a [routerLink]="['/relnotes']" [queryParams]="{ releaseNo: getApplicationReleaseNumber(search) }" style='text-decoration:underline' target="_blank" ><span class="tag__title"> {{ search }} </span>
                            </a> -->
                            <span class="tag__icon icon-close" (click)="removeParticularFilter(search,searchAppFilter,'appName')"></span>
                        </div>

                    </mat-chip>


                    <input [matChipInputFor]="chipList" #searchValue [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="false" (matChipInputTokenEnd)="addFilter(searchValue.value,'search')" (keyup.escape)="removeFilter()" [(ngModel)]="searchapplication"
                        autofocus  >
                </mat-chip-list>
                <span class="search__icon icon-close" (click)="removeFilter()"></span>
            </mat-form-field>
            <!-- <button [disabled]="!searchapplication" class="btn btn--primary search-btn" (click)="addFilter(searchValue.value,'search')">Search</button> -->
            <!-- <button [disabled]="!searchapplication" class="btn btn--primary " 
            [ngClass]="[!platform.SAFARI ? 'search-btn-safari' : 'search-btn' ,!platform.SAFARI && searchapplication ? 'search-btn-safari-clicked':'']"
            (click)="addFilter(searchValue.value,'search')">Search</button> -->
            <!-- <button [disabled]="!searchapplication" class="btn btn--primary " 
            [ngClass]="[platform.SAFARI ? 'search-btn-safari' : 'search-btn' ,platform.SAFARI && isFilterApplied ? 'search-btn-safari-clicked':'search-btn']"
            (click)="addFilter(searchValue.value,'search')">Search</button> -->

            
            <button *ngIf="platform.SAFARI" [disabled]="!searchapplication" class="btn btn--primary " 
            [ngClass]="[platform.SAFARI ? 'search-btn-safari' : '' ,platform.SAFARI && isFilterApplied ? 'search-btn-safari-clicked':'search-btn-safari']"
            (click)="addFilter(searchValue.value,'search')">Search</button>
            
            <button *ngIf="!platform.SAFARI" [disabled]="!searchapplication" class="btn btn--primary search-btn" (click)="addFilter(searchValue.value,'search')">Search</button>
            <div *ngIf="searchAppFilterLength > 0" class="tooltip tooltip--top"  style=" opacity: 1; " (click)="copyToClipboard()">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.74113 3.72416L10.4881 2.00127C11.2277 1.33641 12.1986 0.978185 13.1991 1.00103C14.1996 1.02387 15.1527 1.42603 15.8604 2.12393C16.568 2.82184 16.9758 3.76182 16.999 4.74854C17.0221 5.73526 16.6589 6.69284 15.9848 7.42229L13.4879 9.87611C13.128 10.2323 12.7004 10.515 12.2295 10.7079C11.7586 10.9007 11.2538 11 10.7439 11C10.2341 11 9.72922 10.9007 9.25835 10.7079C8.78748 10.515 8.35985 10.2323 8 9.87611" stroke="#7E868F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.25887 14.2758L7.51193 15.9987C6.7723 16.6636 5.80135 17.0218 4.80086 16.999C3.80037 16.9761 2.84727 16.574 2.13962 15.8761C1.43198 15.1782 1.02421 14.2382 1.00104 13.2515C0.977881 12.2647 1.34111 11.3072 2.01525 10.5777L4.51214 8.12389C4.87199 7.76766 5.29962 7.48501 5.77049 7.29215C6.24136 7.09928 6.7462 7 7.25607 7C7.76593 7 8.27078 7.09928 8.74165 7.29215C9.21252 7.48501 9.64015 7.76766 10 8.12389" stroke="#7E868F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                      <div id="linkClicked" [ngClass]="getLinkcopiedCss()" > {{linkedHoverCopiedText}}</div>
                </div>
            <!--  <div class="alert__icon icon-information tooltip tooltip--top">
            </div>  --> 
            <!-- <div tabindex="0" class="alert" *ngIf="searchAppFilterLength > 0"> -->
                
              
                <!-- <div class="linkedCopied" *ngIf="isLinkCopied" id="linkClicked">Copied to clipboard</div>   -->
            <!-- </div> -->
            
        </div>
        
        <!-- <div class="col-md-1 col-sm-2 search-outer">

                 <button class="btn btn--primary" (click)="addFilter(searchValue.value,'search')">Search</button>
        </div>-->

        <!--  <div class="col-1 mt-10 appCount" style="margin-left: -1%;">
            <h4 style="margin-top: 20%;"><span> {{ applicationCount | number}}
                </span></h4>
        </div> -->

        <!--Mat chips-->
        
    </div>
    <!-- <div class="row" style="padding-left: 15px;" >
        <div id="autoPopAppDropdown" class="dropdown-content" style="display: block;">
            
            <a *ngFor="let item of applicationNamesForAutoIntermidiate" 
            (click)="selectApplication(item)" >{{item}}</a>
            
        </div>
        
    </div> -->
    <!-- <h2 class="app-status-head">All Application Status</h2> -->

    <div class="row">
        <div class="col-md-12 tab-btns">
            <div class="btn-group btn-group--square">
                <button class="btn btn--ghost " [ngClass]="{'btn--state-selected':activeIndex===1}" (click)="showRisk()" #btnRiskClick>Risk</button>
                <button class="btn btn--ghost" [ngClass]="{'selected':activeIndex===2}" (click)="showTags()">Tags</button>
                <button class="btn btn--ghost" [ngClass]="{'selected':activeIndex===3}" (click)="showCategories()">Categories</button>
            </div>
        </div>
    </div>
    <div class="row condTable">
        <div class="col-md-4 col-sm-12 mob-mb20 CADSmallTableContainer relevance-table" *ngIf="riskTable">
            <div class="CADSmallTable">
                <div class="table__header-row CADSmallTableHeader">
                    <div class="table__header-cell status-cell">Risk</div>
                    <!-- <div class="table__header-cell risk-cell">Risk</div> -->
                    <div class="table__header-cell rel-cell">Business Relevance</div>
                </div>
                <div class="CADSmallTableBody scrollbar scrollbar--direction-vertical">
                    <!--row starts -->
                    <div class="table__row CADSmallTableRow" *ngFor="let index of riskBuinessArr" style="min-height: 35px;">
                        <div *ngIf="index < riskDetailsList.length" class="CADSmallTableRowHalf" (click)="addFilter(riskDetailsList[index].appIndex,'Risk')">
                            <div class="table__cell" style="width:100%; cursor: pointer;">
                                <span  class="risk-tag" onmouseover="style='text-decoration:underline';cursor:'pointer';" onmouseout="style='text-decoration:none'"  [ngClass]="getRiskFilterCSS(riskDetailsList[index].appIndex)">
                                    <img [src]="getRiskLevelIcon(riskDetailsList[index].appIndex)" style="padding-right: 1px;"/> {{getRiskLevel(riskDetailsList[index].appIndex) }}</span>
                            </div>
                            <div class="table__cell" >
                            <a routerLink class="tag" onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'" style="font-size: 12px;">
                                {{riskDetailsList[index].appCount | number }}
                            </a>
                            </div>
                        </div>

                        <div *ngIf="index < relevanceDetailsList.length" class="CADSmallTableRowHalf" (click)="addFilter(relevanceDetailsList[index].appIndex,'Business Relevance')">
                            <div class="table__cell rel-status" style="width:100%; cursor: pointer;">
                                    <p class="m-0 tag"><a onmouseover="style='text-decoration:underline';cursor:'pointer';" onmouseout="style='text-decoration:none'">{{getRiskLevel(relevanceDetailsList[index].appIndex) }}</a></p>
                                   <!-- <p class="m-0">
                                        <span class="status-lines stat-active" *ngFor="let brcount of counter(relevanceDetailsList[index].appIndex)"></span>
                                        <span class="status-lines" *ngFor="let brcount of counter(5-relevanceDetailsList[index].appIndex)"></span>
                                    </p> -->
                            </div>
                            <div class="table__cell rel-count" >
                                <a routerLink class="tag" onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'" style="font-size: 12px;">{{relevanceDetailsList[index].appCount |
                                    number }}</a></div>
                        </div>
                    </div>
                    <!--row ends -->
                </div>

            </div>
        </div>

        <div class="col-md-4 col-sm-12 mob-mb20 CADSmallTableContainer twoEntries" *ngIf="tagsTable">
            <div class="CADSmallTable">
                <div class="table__header-row CADSmallTableHeader">
                    <div class="table__header-cell"> Tags</div>
                    
                    <div class="table__header-cell">
                        <a  (click)="showAllTags()" style="font-weight: 700;color: #1D69CC;" onmouseover="style='text-decoration:underline;color: #1D69CC;  cursor: pointer'" onmouseout="style='text-decoration:none;color: #1D69CC;'">
                            Show All Tags</a> 
                    </div>
                </div>
                <div class="CADSmallTableBody scrollbar scrollbar--direction-vertical">
                    <ng-container *ngIf="isCiscoUser">
                    <div class="table__row CADSmallTableRow" *ngFor="let tag of tagsList | type:'tag' " style="min-height: 35px;" > 
                        <!-- <div class="table__row CADSmallTableRow" *ngFor="let tag of tagsList"> -->
                       
                        <div class="CADSmallTableRowHalf" style="width: 70%;" (click)="addFilter(tag.name,'tag')" >
                            <div class="table__cell">
                                <div class="table__cell"><a class="tag" routerLink onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'">{{tag.name}}</a></div>
                            </div>
                        </div>
                        <div class="CADSmallTableRowHalf"  (click)="addFilter(tag.name,'tag')">
                            <div class="table__cell tb-right" >
                                <a routerLink class="tag" onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'" style="font-size: 12px;">{{tag.applicationCount }}</a>
                            </div>
                        </div>

                    </div>
                   </ng-container>  
                   <ng-container *ngIf="!isCiscoUser">
                    <div class="table__row CADSmallTableRow" *ngFor="let tag of nonCiscoUsertagsList | type:'tag' " style="min-height: 35px;" > 
                        <!-- <div class="table__row CADSmallTableRow" *ngFor="let tag of tagsList"> -->
                       
                        <div class="CADSmallTableRowHalf" style="width: 70%;" (click)="addFilter(tag.name,'tag')" >
                            <div class="table__cell">
                                <div class="table__cell"><a class="tag" routerLink onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'">{{tag.name}}</a></div>
                            </div>
                        </div>
                        <div class="CADSmallTableRowHalf"  (click)="addFilter(tag.name,'tag')">
                            <div class="table__cell tb-right" >
                                <a routerLink class="tag" onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'" style="font-size: 12px;">{{tag.applicationCount }}</a>
                            </div>
                        </div>

                    </div>
                   </ng-container>  
                </div>

            </div>
        </div>

        <div class="col-md-4 col-sm-12 mob-mb20 CADSmallTableContainer twoEntries" *ngIf="categoriesTable">
            <div class="CADSmallTable">
                <div class="table__header-row CADSmallTableHeader">
                    <div class="table__header-cell">Categories</div>
                    <div class="table__header-cell"></div>
                </div>
                <div class="CADSmallTableBody scrollbar scrollbar--direction-vertical">
                    <div class="table__row CADSmallTableRow" *ngFor="let category of tagsList | type:'category'" style="min-height: 35px;">
                        <!-- <div class="table__row CADSmallTableRow" *ngFor="let category of tagsList"> -->
                        <div class="CADSmallTableRowHalf" style="width: 70%;" (click)="addFilter(category.name,'category')">
                            <div class="table__cell">
                                <div class="table__cell"><a routerLink class="tag" onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'">{{
                                        category.name }}</a></div>
                            </div>
                        </div>
                        <div class="CADSmallTableRowHalf" (click)="addFilter(category.name,'category')">
                            <div class="table__cell tb-right" >
                                <a routerLink class="tag" onmouseover="style='text-decoration:underline'" onmouseout="style='text-decoration:none'">{{ category.applicationCount }}</a>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
    <h2 class="p-b10 p-t10 app-details-mob">
        Application Details ({{ applicationCount | number}})

        <span style="padding: 10px;" *ngIf="applicationNameArray.length>0 && !isMobile">
        <font size="-1">
            Release Notes (<b>{{applicationReleaseNameWithOutSpace}}</b>):  
            <a  *ngFor="let rel of releaseNumberArray" 
            href="relnotes/?releaseNo={{rel}}#{{applicationReleaseName}}" 
            target="{{applicationReleaseName}}">
            <span style="padding: 2px;" 
            onmouseover="style='text-decoration:underline;padding: 2px;'" 
            onmouseout="style='text-decoration:none;padding: 2px;'">
            </span>
                <div class="tooltip tooltip--top" style="opacity: 2;" (mouseover)="ShowRelDates(rel)">{{rel}}
                    <div class="tooltip__text_dates"  style="opacity: 2;" >{{releaseDate}}</div>
                </div>
            </a>
        </font>
        <!-- <div class="context context--state-info context--right" >
            <span class="context__arrow"></span>
            <div class="context__icon icon-information"></div>
            <div class="context__message">New feature added to search application in releasenotes. Click on links to
                navigate.</div>
        </div> -->
        <div class="alert__icon icon-information tooltip tooltip--top" style="opacity: 2;" >
            <div class="tooltip__text_dates_info">Click on links to navigate. Hover to see release dates for each release.</div>
        </div>
    </span> 
    </h2>
    <div class="row">
        <span style="padding: 5px; padding-left: 15px;" *ngIf="applicationNameArray.length>0 && isMobile">
            <font size="-1">
                <b>{{applicationReleaseNameWithOutSpace}}</b> found in Release Notes: 
                <a  *ngFor="let rel of releaseNumberArray" href="relnotes/?releaseNo={{rel}}#{{applicationReleaseName}}" target="{{applicationReleaseName}}"><span style="padding: 2px;" onmouseover="style='text-decoration:underline;padding: 2px;'" onmouseout="style='text-decoration:none;padding: 2px;'"></span>
                    <div class="tooltip tooltip--top" (touchstart)="ShowRelDates(rel)">{{rel}}
                        <div class="tooltip__text">{{releaseDate}}</div>
                    </div>
                </a>
            </font>
            <div class="alert__icon icon-information tooltip tooltip--top">
                <div class="tooltip__text">Click on links to navigate. Touch to see release dates for each release.</div>
            </div>
        </span>
    </div>
    
    <div class="row appDetTable p-b20">
        <div class="col-12 CADSmallTableContainer">
            <div class="CADSmallTable CADTableFull" style="height: auto;">
                <div class="table__header-row CADSmallTableHeader">

                    <div class="table__header-cell"><span class="icon-condensed-spacing"></span></div>
                    <!-- <div class="table__header-cell" [ngClass]="getSortingClass('appName')" (click)="sortBy('appName',false)">Application Name</div> -->
                    <div class="table__header-cell" [ngClass]="getSortingClass('appName')" (click)="sortBy('appName',true)">Application Name</div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('appDescription')" (click)="sortBy('appDescription',true)">Description</div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('riskIndex')" (click)="sortBy('riskIndex',true)">Risk</div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('productivityIndex')" (click)="sortBy('productivityIndex',true)">Business Relevance</div>
                </div>
                <!--  <div class="scrollbar scrollbar--direction-vertical CADSmallTableBody" style="height: 300px;"
                    (scroll)="scrollHandler($event)"> -->
                <cdk-virtual-scroll-viewport  class="scrollbar scrollbar--direction-vertical CADSmallTableBody" style="height: 500px; padding-left: 16px;" itemSize="32">
                    <div *ngIf="filteredApplicationList.length ==0 ">
                        <div class="table__row CADSmallTableRow no-records-bg">
                            <div class="table__cell"></div>
                            <div class="table__cell"></div>
                            <div class="table__cell">
                                <div class="no-records">No records to display.</div>
                            </div>
                        </div>
                    </div>
                    <div *cdkVirtualFor="let app of customersObservable ; let index=index; templateCacheSize:0" style="Padding-left: 16px; padding-right: 16px;cursor: pointer;">
                       
                        <div *ngIf="filteredApplicationList.length ==1 && app.parentId!=0" class="table__row CADSmallTableRow">

                            <div class="table__cell"></div>
                            <div class="table__cell" *ngIf="app.parentId!=0">{{ app.parentName }}</div>

                        </div>
                       
                        <!-- <div class="table__cell" *ngIf="app.parentName!=0">{{ app.parentName }}</div> -->
                        <div #divClick class="table__row CADSmallTableRow"  id="{{ 'applicationrowdata-' + index }}" (click)="toggleAccordian(index)" style="cursor: pointer;">
                            
                            <div class="table__cell"><span id="{{ 'accordianbtn-' + index }}" class="accordion__toggle icon-chevron-right"></span></div>
                            <div class="table__cell">{{ app.appName1 }}</div>
                            <div class="table__cell">{{ app.appDescription }}</div>
                            <div class="table__cell pl20"><span [ngClass]="getRiskCSSDataNew(app.riskIndex)">
                               <img [src]="getRiskLevelIcon(app.riskIndex)" style="padding-right: 2px;"/>  
                                {{getRiskLevel(app.riskIndex) }}</span></div>
                            <div class="table__cell pl20 rel-data-tb">
                              <p class="m-0 tag">{{getRiskLevel(app.productivityIndex) }}</p>
                              <!--<p class="m-0" *ngIf="app.productivityIndex>0">
                                    <span class="status-lines stat-active" *ngFor="let brcount of counter(app.productivityIndex)"></span>
                                    <span class="status-lines" *ngFor="let brcount of counter(5-app.productivityIndex)"></span>
                              </p> -->
                            </div>
                        </div>

                        <!--row starts -->
                        <div class="table__row CADSmallTableRow ltbluebg" id="{{ 'object-' + index }}" style="display: none; cursor: pointer;">
                            <div class="table__cell"></div>
                            <div class="table__cell" style="width: 77% !important;">
                                <div class="innerFirstRow">
                                    <div class="innerCell">
                                        <p style="width: 75px;"><strong>Tags:</strong></p>
                                    </div>
                                    <div class="innerCellVal" *ngFor="let tagsvalue of app.tags| splitComma" >
                                        <p class="tag">{{ tagsvalue}}</p>
                                    </div>
                                </div>
                                <div class="innerSecondRow">
                                    <div class="innerCell"  >
                                        <p><strong>Categories:</strong></p>
                                    </div>
                                    <div class="innerCellVal" *ngFor="let subcategory of app.category| splitComma">
                                        <p class="tag">{{ subcategory }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="table__cell" style="width: 22% !important;">
                                <div class="innerFirstRow">
                                    <div class="innerCell">
                                        <p><strong>Protocol:</strong></p>
                                    </div>
                                    <div class="innerCellVal">
                                        <p>{{ app.protocol }}</p>
                                    </div>
                                </div>
                                <div class="innerSecondRow">
                                   <!--  <div class="innerCell">
                                        <p><strong>Support:</strong></p>
                                    </div> -->
                                    <div class="innerCellVal">
                                        <p class="reqAppln">
                                            <!-- <a class="alert__icon icon-information" href="tacsupport"></a> -->
                                            <a href="tacsupport"><span class="result-link-color">Request Application Support</span></a>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="table__cell">
                            </div> -->
                        </div>
                        <!--row ends -->
                    </div>
                </cdk-virtual-scroll-viewport>
                <!-- </div> -->
                <!-- <div *ngIf="filteredApplicationList.length ==0 ">
                    <div class="table__row CADSmallTableRow" style="background-color: #EBFAFF">
                        <div class="table__cell"></div>
                        <div class="table__cell"></div>
                        <div class="table__cell">
                            <div style="text-align: center;">No records to display.</div>
                        </div>
                    </div>
                </div> -->

                <!-- </div> -->
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="mob-accordion">
                <cdk-virtual-scroll-viewport class="scrollbar scrollbar--direction-vertical CADSmallTableBody" style="height: 500px" itemSize="32">
                    <div class="mob-app-title">Application</div>
                    <div *ngIf="filteredApplicationList.length ==0 ">
                        <div class="table__row CADSmallTableRow no-records-bg">
                            <div class="table__cell">
                                <div class="no-records">No records to display.</div>
                            </div>
                        </div>
                    </div>
                    <mat-accordion>
                        <!-- #enddocregion multi -->
                        <mat-expansion-panel class="example-headers-align" multi=false *cdkVirtualFor="let app of customersObservable ; let index=index;" (opened)="setOpened(index)" (closed)="setClosed(index)" [expanded]="applicationCount===1">
                      
                            <mat-expansion-panel-header>

                                <mat-panel-title *ngIf="filteredApplicationList.length ==1 && app.parentId!=0">
                                    <b>{{ app.parentName }}</b><hr>
                                </mat-panel-title>
                                
                                <mat-panel-title>
                                    {{ app.appName1 }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <!-- <mat-panel-description> -->
                            <p>{{ app.appDescription }}</p>
                            <p ><strong>Risk</strong><span class="risk-tag tb-tag" [ngClass]="getRiskCSSDataNew(app.riskIndex)"  style="font-size: 14px;">{{
                                    getRiskLevel(app.riskIndex) }}</span></p>
                            <p  style="font-size: 14px;"><strong>Business Relevance: </strong>
                                <span class="d-block">
                                    <span class="br-txt">{{getRiskLevel(app.productivityIndex) }}</span>
                                <span class="br-lines">

                                        <span class="status-lines stat-active"
                                            *ngFor="let brcount of counter(app.productivityIndex)"></span>
                                <span class="status-lines" *ngFor="let brcount of counter(5-app.productivityIndex)"></span>

                                </span>
                                </span>
                            </p>

                            <!-- </mat-panel-description> -->

                            <p><strong>Tags: </strong>{{ app.tags }}</p>
                            <p><strong>Categories: </strong>{{ app.category }}</p>
                            <p><strong>Protocol: </strong>{{ app.protocol }}</p>
                            <p><!-- <strong>Support: </strong>
                                <a class="alert__icon icon-information" href="tacsupport"></a> -->
                                <a href="tacsupport"><span class="result-link-color">Request Application Support</span></a>
                            </p>
                        </mat-expansion-panel>
                    </mat-accordion>
                </cdk-virtual-scroll-viewport>
            </div>
        </div>
    </div>

    <footer class="footer" style="padding-right: 16px;">
        <div class="footer__legal">
            <div class="row">
                <div class="col-md-2">
                    @ 2023 Cisco Systems, Inc.
                </div>
                <div class="col-md-6">

                </div>
                <div class="footer_lower col-md-4" >
                    <a href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html" style="
                    font-weight: 700;color: #1D69CC;">Privacy policy</a>
                
                    <a href="https://www.cisco.com/c/en/us/about/legal/terms-conditions.html" style="padding-left: 18px;
                    font-weight: 700;color: #1D69CC;">Terms of service</a>
                </div>    
            </div>
        </div>
    </footer>
</div>

